import React from 'react';
import { ProjectTag, StyledLabeledListItem } from '../Shared/Styled';
import '../../utils/scrollIntoViewIfNeeded';
import { ThemeString, useThemeContext } from '../../context';
import { ItemIcon } from './SelectList';
import ReactDOMServer from 'react-dom/server';
import * as Icon from '@itwin/itwinui-icons-react';
import { primaryTextColor } from '../../styles/SharedStyles';

interface LabeledItemListProps {
  items: {
    label?: string;
    value?: string;
    text?: string;
    additionalText?: string;
    external?: boolean;
    isPw365Project?: boolean;
    linkToUrl?: string;
  }[];
}

export function LabeledItemList({ items }: LabeledItemListProps) {
  const theme = useThemeContext();

  return (
    <ul
      style={{
        listStyleType: 'none',
        paddingLeft: '0',
        margin: '0',
        position: 'relative',
        flexGrow: 1,
        overflowY: 'auto',
        boxSizing: 'border-box',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      {items.map((item, index) => {
        return (
          <div key={index}>
            <LabeledItem item={item} index={index} theme={theme} />
          </div>
        );
      })}
    </ul>
  );
}

interface LabeledItemProps {
  item: {
    label?: string;
    value?: string;
    text?: string;
    additionalText?: string;
    isPw365Project?: boolean;
    external?: boolean;
    linkToUrl?: string;
  };
  theme: ThemeString;
  index: number;
}

function LabeledItem({ item, theme, index }: LabeledItemProps) {
  return (
    <div>
      <StyledLabeledListItem
        item={item}
        index={index}
        selected={false}
        themeStr={theme}
        hasBorder={false}
        data-testid={`labeled_list_item_${index}`}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
            wordWrap: 'break-word',
            justifyContent: 'space-between',
            fontSize: '14px',
          }}
        >
          <a style={{ fontWeight: 'bold' }}>{item.label}</a>

          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            {item.additionalText && (
              <p
                style={{
                  marginLeft: '24px',
                  fontSize: '14px',
                  display: 'flex',
                  flexFlow: 'row',
                  verticalAlign: 'center',
                }}
              >
                <div style={{ display: 'flex', flexFlow: 'row' }}>
                  <a
                    href={item.linkToUrl}
                    rel='noopener noreferrer'
                    target='_blank'
                    style={{
                      color: primaryTextColor(theme),
                    }}
                  >
                    {item.additionalText}
                  </a>
                  {item.linkToUrl && (
                    <ItemIcon
                      icon={ReactDOMServer.renderToStaticMarkup(
                        Icon.SvgWindowPopout({
                          width: '10px',
                        })
                      )}
                      theme={theme}
                      style={{ padding: '0px', paddingLeft: '5px' }}
                    />
                  )}
                </div>

                {item.isPw365Project && (
                  <ProjectTag
                    type='pw365'
                    style={{
                      marginLeft: '6px',
                      height: '75%',
                      top: '3px',
                    }}
                  >
                    PW365
                  </ProjectTag>
                )}
                {item.external && (
                  <ProjectTag
                    style={{
                      height: '75%',
                      top: '3px',
                    }}
                  >
                    External
                  </ProjectTag>
                )}
              </p>
            )}
            <p style={{ marginLeft: '24px', fontSize: '14px' }}>{item.text}</p>
          </div>
        </div>
      </StyledLabeledListItem>
    </div>
  );
}
